import { Link, useLocation } from "react-router-dom";
import { Phone, CalendarHeart, MessageCircleHeart, MessageCircle } from "lucide-react";
import { CLINIC } from "@/lib/api";

const item = "flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold";

export const MobileBar = () => {
  const { pathname } = useLocation();
  const ask = () => (pathname === "/ask"
    ? document.querySelector("[data-testid='ai-chat-input']")?.focus()
    : window.dispatchEvent(new Event("tb:open-sparkle")));
  return (
  <nav className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-4 border-t border-teal-100 bg-white/95 backdrop-blur-xl sm:hidden"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="mobile-action-bar">
    <a href={`tel:${CLINIC.phoneRaw}`} className={`${item} h-16 text-sky-600`} data-testid="mobile-bar-call"><Phone className="h-5 w-5" />Call</a>
    <a href={CLINIC.whatsapp} target="_blank" rel="noreferrer" className={`${item} h-16 text-[#16a34a]`} data-testid="mobile-bar-whatsapp"><MessageCircle className="h-5 w-5" />WhatsApp</a>
    <Link to="/book" className={`${item} h-16 text-[#ff6b6b]`} data-testid="mobile-bar-book"><CalendarHeart className="h-5 w-5" />Book</Link>
    <button onClick={ask} className={`${item} h-16 text-teal-700`} data-testid="mobile-bar-sparkle">
      <MessageCircleHeart className="h-5 w-5" />Ask Sparkle
    </button>
  </nav>
  );
};
